const AppColors = {
    mainColor: '#EE7F0D',
    bgColor: 'rgba(238, 127, 13, 0.14)',
    bgColorLight: 'rgba(238, 127, 13, 0.02)',
    solidGrey: '#66738F'
}

module.exports = AppColors;